window.inquiry_formHeadingFn = function(formId, blockId) {
  if (!formId) return;
  var iframeWrapper = document.getElementById(formId);
  var iframeElm = iframeWrapper.querySelector('iframe');
  if (iframeElm) {
    if (iframeElm.src.includes('about:blank')) {
      iframeWrapper.classList.add('loading');
      iframeElm.addEventListener('load', function () {
        iframeWrapper.classList.remove('loading');
      });
      iframeElm.src = iframeElm.getAttribute('data-src');
    }
    inquiry_toggleFormOpenAttribute(formId) && inquiry_scrollToElement(formId, false, blockId);
  }
  else {
    var headerHeight = 69;
    window.scrollTo({ top: iframeWrapper.offsetTop - headerHeight, behavior: 'smooth' });
  }
}
window.inquiry_verticalBtnFn = function(formId, blockId) {
  if (!formId) return;
  var iframeWrapper = document.getElementById(formId);
  if (iframeWrapper.getAttribute('data-collapsible-form-open') == 'true') {
    inquiry_scrollToElement(formId, false, blockId);
  }
  else {
    inquiry_formHeadingFn(formId, blockId);
  }
}